// From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseInt#Polyfill
export default function parseInt() {
  if (Number.parseInt === undefined) {
    // we use [key] access because dot notation throws a TS error
      Number.parseInt = window['parseInt'];
  }
}

parseInt();
